import React, { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from "@mui/material";

export interface InputDialogProps
  extends Omit<
    DialogProps,
    "onClose" | "open" | "style" | "inputValue" | "handler"
  > {
  title: string;
  onConfirm: (onClose: () => void) => Promise<void>;
  onClose: () => Promise<void>;
  open?: boolean;
  children: React.ReactNode;
  cancelText?: string;
  confirmText?: string;
  isConfirmDisabled?: boolean;
}

export const InputDialog: FC<InputDialogProps> = (props) => {
  const {
    title,
    sx,
    onConfirm,
    onClose,
    open,
    children,
    isConfirmDisabled = false,
    cancelText = "Cancel",
    confirmText = "Done",
    ...rest
  } = props;

  return (
    <Dialog
      //onClose={onClose}
      {...rest}
      sx={sx || {}}
      open={open || false}
      style={{ minWidth: "450px" }}
    >
      {title && (
        <DialogTitle sx={{ marginBottom: "16px" }}>{title}</DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelText}</Button>
        <Button
          disabled={isConfirmDisabled}
          onClick={() => onConfirm(onClose)}
          variant="contained"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
